// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navBox[data-v-5d6e115c] {\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n}\n.page-content[data-v-5d6e115c] {\n  width: 100%;\n  height: 100%;\n  opacity: 0.2;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.page-font-content[data-v-5d6e115c] {\n  display: flex;\n  word-wrap: break-word;\n  word-break: break-all;\n}", ""]);
// Exports
module.exports = exports;
